import { Button, Stack, Typography, useTheme } from "@mui/material";
import React from "react";

export default function AddToCartBtn({
  fullPrice,
  handleAddToCart,
  disabled,
  call,
}) {
  const theme = useTheme();

  return (
    <Stack
      direction={{ xs: "column", sm: "row-reverse" }}
      sx={{
        width: "100%",
        mt: 1.5,
        borderRadius: "16px",
        justifyContent: "space-between",
        alignItems: "center",
        p: { xs: "0.8rem", sm: "0.6rem" },
        gap: { xs: 1.5, sm: 0 },
        backgroundColor: "rgba(0, 0, 0, 0.15)",
        border: "1px solid rgba(255, 255, 255, 0.04)",
        backdropFilter: "blur(12px)",
        boxShadow: "inset 0 2px 10px rgba(0,0,0,0.2)",
      }}
    >
      {call ? (
        <Typography
          sx={{
            width: "100%",
            fontSize: "0.95rem",
            fontWeight: "bold",
            textAlign: "center",
            color: theme.palette.primary.main,
          }}
        >
          برای اطلاع از قیمت تماس بگیرید
        </Typography>
      ) : disabled ? (
        <Typography
          sx={{
            width: "100%",
            fontSize: "0.95rem",
            fontWeight: "bold",
            textAlign: "center",
            color: theme.palette.error.main,
            opacity: 0.8,
          }}
        >
          ناموجود در انبار
        </Typography>
      ) : (
        <>
          <Button
            onClick={handleAddToCart}
            sx={{
              width: { xs: "100%", sm: "40%" },
              py: "10px",
              borderRadius: "12px",
              color: theme.palette.background.default,
              backgroundColor: theme.palette.primary.main,
              fontSize: "0.95rem",
              fontWeight: 800,
              boxShadow: `0 6px 15px ${theme.palette.primary.lowOpacity}`,
              transition: "all 0.3s cubic-bezier(0.2, 0.8, 0.2, 1)",
              "&:hover": {
                backgroundColor: theme.palette.primary.dark || "#C49A45",
                transform: "translateY(-2px)",
                boxShadow: `0 8px 20px ${theme.palette.primary.lowOpacity}`,
              },
            }}
          >
            افزودن به سبد خرید
          </Button>

          <Typography
            sx={{
              width: { xs: "100%", sm: "55%" },
              textAlign: { xs: "center", sm: "right" },
              color: theme.palette.text.primary,
              fontSize: "0.95rem",
              fontWeight: 700,
            }}
          >
            مجموع:{" "}
            <span
              style={{
                color: theme.palette.primary.main,
                fontSize: "1.1rem",
                marginRight: "6px",
              }}
            >
              {fullPrice?.toLocaleString("fa-IR")}
            </span>{" "}
            <span
              style={{
                fontSize: "0.85rem",
                color: theme.palette.text.secondary,
              }}
            >
              تومان
            </span>
          </Typography>
        </>
      )}
    </Stack>
  );
}
